import http from '../http'

const BASE_URL = 'permission'

class PermissionAPI {

  async save(permission) {
    const response = await http.post(`${BASE_URL}`, 'POST', { 
      name: permission, 
      status: 1 
    })
    return response || null
  }

  async getAll() {
    const response = await http(`${BASE_URL}`)
    return response || null
  }

  async get(permissionID) {
    const response = await http(`${BASE_URL}/${permissionID}`)
    return response || null
  }

  async update(permissionID, permission, status) {
    const response = await http(`${BASE_URL}/update/${permissionID}`, 'PUT', { 
      name: permission, 
      status: status 
    })
    return response || null
  }

}

export default new PermissionAPI()